import store from '@js/store';
import { INIT_STORE as INIT_EVENT_STORE } from '@js/store/events/action-types';

export const loadToVuexStore = (action, payload, callback) => {
	store.dispatch(action, payload).then(callback);
};

if (window.StoreLoader?.events) {
	Object.keys(window.StoreLoader.events).forEach((storeName) => {
		loadToVuexStore(INIT_EVENT_STORE, { storeId: storeName, data: window.StoreLoader.events[storeName] }, () => {
			delete window.StoreLoader.events[storeName];
		});
	});
}
